import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { BuilderContext } from '../store/store.Builder'
import LoadingPage from '../../../../components/Loading/LoadingPage'
import { toJS } from 'mobx'

const AuthorizationGuard = observer(({ children }) => {
  const navigate = useNavigate()
  const builderContext = useContext(BuilderContext)
  const [loading, setLoading] = useState(true)
  const flag = useRef(false)

  useEffect(() => {
    if (flag.current === false) {
      const checkPermission = async () => {
        await builderContext.initialisationGET()
        if (!builderContext.hasPermission) {
          navigate('/forbidden')
        }
        try {
          await builderContext.initialiseFields()

          console.log(toJS(builderContext.data.fields))
        } catch (e) {
          console.log('eee', e)
        }

        setLoading(false)
      }
      checkPermission()
      const fetchData = async () => {
        try {
          builderContext.initialisationGETCollectFormAnswersData()
        } catch (error) {
          console.error('An error occurred while fetching data:', error)
        }
      }
      fetchData()
    }

    return () => (flag.current = true)
  }, [navigate])

  useEffect(() => {
    const handleKeyPress = (e) => {
      // Pour Ctrl + Z
      if (e.ctrlKey && (e.key === 'z' || e.key === 'Z') && !e.shiftKey) {
        builderContext.undo()
      }
      // Pour Ctrl + Shift + Z
      else if (e.ctrlKey && (e.key === 'z' || e.key === 'Z') && e.shiftKey) {
        builderContext.redo()
      }
    }

    document.addEventListener('keydown', handleKeyPress)

    // Cleanup
    return () => {
      document.removeEventListener('keydown', handleKeyPress)
    }
  }, [builderContext])

  useEffect(() => {
    if (builderContext.hasPermission === false) {
      navigate('/forbidden')
      // console.log('je redirige')
    }
  }, [builderContext.hasPermission, navigate])

  if (loading) {
    return <LoadingPage />
  }

  return children
})

export default AuthorizationGuard
